import React, { useEffect, useState } from "react";
import img from "../../assets/images/Dress Code.jpg";
import Skeleton from "@mui/material/Skeleton";
import CloseIcon from "@mui/icons-material/Close";
import Microlink from "@microlink/react";

const PreviewPostCard = ({ text, setInputs, previewLink, setPreviewLink }) => {
  const [previewData, setPreviewData] = useState(null);
  const [loading, setLoading] = useState(false);

  const extractURL = (str) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const match = str.match(urlRegex);
    return match ? match[0] : null;
  };

  const extractDomain = (url) => {
    try {
      const domain = new URL(url).hostname.replace("www.", "");
      return domain;
    } catch (error) {
      return url;
    }
  };

  const extractFakeTitle = (url) => {
    try {
      const pathname = new URL(url).pathname.split("/").filter(Boolean);
      if (pathname.length > 0) {
        return pathname[pathname.length - 1].replace(/[-_]/g, " ");
      }
      return "Website Preview";
    } catch {
      return "Website Preview";
    }
  };

  // Get favicon or fallback to your own image
  const getThumbnail = (url) => {
    const domain = new URL(url).hostname;
    return `https://www.google.com/s2/favicons?domain=${domain}&sz=128`;
  };

  useEffect(() => {
    if (!text) {
      setPreviewData(null);
      return;
    }

    setLoading(true);
    const url = extractURL(text);

    if (url) {
      const fakeData = {
        title: extractFakeTitle(url),
        description: extractDomain(url),
        image: getThumbnail(url),
        url,
      };

      setTimeout(() => {
        setPreviewData(fakeData);
        setLoading(false);
      }, 1000);
    } else {
      setTimeout(() => {
        setPreviewData({
          title: "Invalid URL",
          description: "",
          image: img,
          url: text,
        });
        setLoading(false);
      }, 1000);
    }
  }, [text]);

  const handleClose = () => {
    setPreviewData(null);
  };

  if (loading) {
    return (
      <div
        style={{
          border: "1px solid #ccc",
          borderRadius: 5,
          padding: 10,
          marginBottom: 8,
          marginTop: 8,
          display: "flex",
          alignItems: "center",
          gap: 10,
          maxWidth: 600,
        }}
      >
        <Skeleton variant="rectangular" width={100} height={70} />
        <div style={{ flex: 1 }}>
          <Skeleton width="60%" height={20} />
          <Skeleton width="40%" height={14} />
        </div>
      </div>
    );
  }

  if (!previewData) return null;

  return (
    <div className="link-preview-section ps-0">
      <Microlink
        url={text}
        size="normal" // 👈 Thoda bada than small
        media="image" // or "logo" or "video"
        style={{
          width: "100%", // Ensures the image takes full width of the container
          height: "auto", // Maintain the aspect ratio
          maxHeight: "100px", // Set a maximum height to control the image size
          objectFit: "cover", // Ensures the image covers the space without distortion
        }}
      />
    </div>
  );
};

export default PreviewPostCard;
